import {mediaTypeLabels} from 'bigdatr-theme';

export type MediaTypeName =
    | 'Out of Home'
    | 'Television'
    | 'STV'
    | 'Regional TV'
    | 'Connected TV'
    | 'Magazine'
    | 'Classified'
    | 'Newspaper'
    | 'Digital'
    | 'Digital Display'
    | 'Digital Video'
    | 'Digital Social'
    | 'Digital Search'
    | 'Regional Radio'
    | 'Radio';

export type MediaTypeInput = {id?: string; name: string; canonicalName: string};

export default class MediaType {
    private data: MediaTypeInput;
    type = 'mediaType' as const;

    static digitalMediaTypes = [
        // these are canonical names
        'Digital',
        'Digital Search',
        'Digital Display',
        'Digital Video',
        'Digital Social',
        // these are names
        'Digital - Display',
        'Digital - Social',
        'Digital - Search',
        'Digital - Video'
    ];

    constructor(input: MediaTypeInput) {
        this.data = input;
    }

    static isClassified(canonicalName: string) {
        return canonicalName === 'Classified';
    }

    static isDigital(canonicalName: string) {
        return MediaType.digitalMediaTypes.includes(canonicalName);
    }

    static isTraditional(canonicalName: string) {
        return !MediaType.digitalMediaTypes.includes(canonicalName);
    }

    static isRadio(canonicalName: string) {
        return ['Regional Radio', 'Radio'].includes(canonicalName);
    }

    static oohId() {
        return 'ac2c56b9-eb09-4d43-806b-0dd7146d904d';
    }

    static connectedTvCanonicalName() {
        return 'Connected TV';
    }

    static connectedTvId() {
        return '310737aa-d9ea-43bd-b5b0-98b7ad5b2679';
    }

    static isOoh(input: string) {
        return input === 'Out of Home' || input === MediaType.oohId();
    }

    static isTv(canonicalName: string) {
        return ['Regional TV', 'Television'].includes(canonicalName);
    }

    static isStv(canonicalName: string) {
        return canonicalName === 'STV';
    }

    get id() {
        return this.data.id || this.data.name;
    }

    get canonicalName() {
        return this.data.canonicalName;
    }

    /** custom names - temporary until we enable renaming. when we enable it use this.data.name */
    get label(): string {
        return mediaTypeLabels[this.canonicalName] || this.canonicalName;
    }

    // new filters label TV media types differently
    get labelV2() {
        if ('Regional TV' === this.canonicalName) return 'FTA TV - Regional';
        if ('Television' === this.canonicalName) return 'FTA TV - Metro';
        if ('Newspaper' === this.canonicalName) return 'Newspaper (Discontinued)';
        if ('Magazine' === this.canonicalName) return 'Magazine (Discontinued)';
        return this.label;
    }

    get color() {
        return undefined;
    }
}
